import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminDashboardComponent } from './layout/admin-dashboard/admin-dashboard.component';
import { DashboardComponent } from './layout/dashboard/dashboard.component';
import { DefaultComponent } from './layout/default/default.component';
import { HomeComponent } from './layout/home/home.component';
import { LoginComponent } from './login/login.component';
import { ProfileComponent } from './profile/profile.component';
import { RegisterComponent } from './register/register.component';
import { TermsComponent } from './terms/terms.component';



const routes: Routes = [
  {
    path:'', component:HomeComponent
  },
  {
    path:'login',component:LoginComponent
  },
  {
    path:'register',component:RegisterComponent,
  },
  {
    path:'blog/:profile_url/:blog_url',component:DashboardComponent,
  },
  {
    path:'blog', component:DefaultComponent
  },
  {
    path:'terms-condition', component:TermsComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
